import type { BaseThemeCompProp } from '../../types';
import Button from '../Button/Button';

const FormButton = ({ children, disabled, onClick }: BaseThemeCompProp) => (
  <Button disabled={disabled} onClick={onClick} type='submit'>
    {children}
  </Button>
);

export default FormButton;
